var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveGameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.524 30.396h7.217a4.987 4.987 0 0 0 3.536-1.5 4.987 4.987 0 0 0 1.439-3.563 5.046 5.046 0 0 0-4.976-4.977H8.858l2.251-2.251a.719.719 0 0 0-.017-1.014.716.716 0 0 0-1 0l-3.475 3.476a.714.714 0 0 0-.091.112.771.771 0 0 0-.068.121.725.725 0 0 0-.038.13.852.852 0 0 0-.014.136.747.747 0 0 0 .01.125v.043c.007.017.018.056.032.094a.752.752 0 0 0 .062.124.762.762 0 0 0 .1.129l3.478 3.478a.719.719 0 0 0 1.014-.017.715.715 0 0 0 0-1L8.858 21.79h8.882a3.589 3.589 0 0 1 3.585 3.585 3.589 3.589 0 0 1-3.585 3.585h-7.221a.71.71 0 0 0-.5.221.712.712 0 0 0-.2.512.717.717 0 0 0 .705.703Z",
    className: "leave-game-icon-b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveGameIcon);
export default __webpack_public_path__ + "static/media/leave-game-icon.204f8f4de68b1db831e160c0a1c7e341.svg";
export { ForwardRef as ReactComponent };